import { useEffect, useMemo } from 'react';

import { isBrowser } from '../utils/web';

export const useSSREffect = isBrowser ? useEffect : useMemo;
